import radioCatalog from './catalog.json';

export interface Station {
  id: string;
  name: string;
  frequency: string;
  label: string;
  description: string;
  itemIds: string[];
  presentation?: 'album';
  artworkUrl?: string;
  artist?: string;
  year?: string;
  tracks?: Array<{ title: string; filename: string }>;
}

export interface Track {
  archiveId: string;
  creator: string;
  filename: string;
  licenseUrl: string;
  sourceTitle: string;
  title: string;
  url: string;
}

export const stationConfig = radioCatalog as Station[];
export const stations = stationConfig;

const cleanFilename = (filename: string) => filename
  .replace(/\.[^.]+$/, '')
  .replace(/[_-]+/g, ' ')
  .replace(/^\d+[.\s]+/, '')
  .trim();

const archiveFileUrl = (identifier: string, filename: string) =>
  `https://archive.org/download/${identifier}/${encodeURIComponent(filename)}`;

export async function loadStationTracks(station: Station): Promise<Track[]> {
  if (station.tracks) {
    return station.tracks.map((track) => ({
      archiveId: '',
      creator: station.artist || station.name,
      filename: track.filename,
      licenseUrl: '',
      sourceTitle: station.name,
      title: track.title,
      url: `/music/${encodeURIComponent(track.filename)}`,
    }));
  }

  const groups = await Promise.all(station.itemIds.map(async (identifier) => {
    const response = await fetch(`https://archive.org/metadata/${identifier}`);
    if (!response.ok) throw new Error('Archive metadata unavailable');
    const data = await response.json();
    const metadata = data.metadata || {};

    return (data.files || [])
      .filter((file: any) => file.format === 'VBR MP3' && !file.private)
      .map((file: any): Track => ({
        archiveId: identifier,
        creator: file.artist || metadata.creator || 'Unknown artist',
        filename: file.name,
        licenseUrl: metadata.licenseurl,
        sourceTitle: metadata.title || identifier,
        title: file.title || cleanFilename(file.name),
        url: archiveFileUrl(identifier, file.name),
      }));
  }));

  return groups.flat();
}
